import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  IconButton,
  Typography,
  TextField,
  Tooltip,
} from '@material-ui/core';
import {
  ArrowBackIos as ArrowBackIosIcon,
  ArrowForwardIos as ArrowForwardIosIcon,
  RotateLeft as RotateLeftIcon,
  RotateRight as RotateRightIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  Restore as RestoreIcon,
  OpenInNew as OpenInNewIcon,
  AspectRatio as FitWidthIcon,
} from '@material-ui/icons';

const DocumentActionsBar = ({
  pdfConfig,
  setPdfConfig,
  onRotateLeft,
  onRotateRight,
  onDownload,
  onOpenInNewTab,
  handleWidthSize,
  zoomSize,
  inputValue,
  setInputValue,
}) => {
  return (
    <Box
      sx={{ 
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: {
          xs: 'space-around',
          sm: 'space-between',
        },
        flexShrink: 0,
        width: '100%',
        position: 'sticky',
        top: -16,
        zIndex: 1000,
        backgroundColor: 'white',
      }}
    >
      <Box style={{ 
        marginLeft: 10,
      }}>
        {pdfConfig.type !== 'document' && (
          <>
            <Tooltip title="Rotar a la izquierda">
              <IconButton
                aria-label="rotar izquierda"
                onClick={onRotateLeft}
                color="inherit"
              >
                <RotateLeftIcon />
              </IconButton>
            </Tooltip>
            
            <Tooltip title="Rotar a la derecha">
              <IconButton
                aria-label="rotar derecha"
                onClick={onRotateRight}
                color="inherit"
              >
                <RotateRightIcon />
              </IconButton>
            </Tooltip>
          </>
        )}

        {pdfConfig.subType !== 'word' && (
          <>
            <Tooltip title="Ajustar al ancho">
              <IconButton
                aria-label="ajustar al ancho"
                onClick={() => handleWidthSize('fitToWidth')}
                color="inherit"
              >
                <FitWidthIcon />
              </IconButton>
            </Tooltip>
            
            <Tooltip title="Zoom in">
              <IconButton
                aria-label="zoom in"
                onClick={() => handleWidthSize('zoomIn')}
                color="inherit"
              >
                <ZoomInIcon />
              </IconButton>
            </Tooltip>
            
            <Tooltip title="Zoom out">
              <IconButton
                aria-label="zoom out"
                onClick={() => handleWidthSize('zoomOut')}
                color="inherit"
              >
                <ZoomOutIcon />
              </IconButton>
            </Tooltip>

            {zoomSize !== 600 && (
              <Tooltip title="Resetear zoom">
                <IconButton
                  aria-label="reset"
                  onClick={() => handleWidthSize('reset')}
                  color="inherit"
                >
                  <RestoreIcon />
                </IconButton>
              </Tooltip>
            )}
          </>
        )}
      </Box>

      {pdfConfig.subType !== 'word' && pdfConfig.is && pdfConfig.numPages > 1 && (
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 2,
        }}>
          <Tooltip title="Página anterior">
            <IconButton
              aria-label="página anterior"
              disabled={pdfConfig.pageNumber <= 1}
              onClick={() => setPdfConfig((prev) => ({
                ...prev,
                pageNumber: Math.max(1, prev.pageNumber - 1),
              }))}
              color="inherit"
            >
              <ArrowBackIosIcon />
            </IconButton>
          </Tooltip>
          
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
          }}>
            <TextField
              variant="standard"
              type="text"
              inputMode="numeric"
              value={inputValue}
              onChange={(e) => {
                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                setInputValue(numericValue);
              }}
              onBlur={(e) => {
                const newPage = parseInt(inputValue);
                if (!isNaN(newPage) && inputValue !== '') {
                  const validatedPage = Math.min(Math.max(1, newPage), pdfConfig.numPages);
                  setPdfConfig((prev) => ({
                    ...prev,
                    pageNumber: validatedPage,
                  }));
                  setInputValue(validatedPage.toString());
                } else {
                  setInputValue(pdfConfig.pageNumber.toString());
                }
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const newPage = parseInt(inputValue);
                  if (!isNaN(newPage) && inputValue !== '') {
                    const validatedPage = Math.min(Math.max(1, newPage), pdfConfig.numPages);
                    setPdfConfig((prev) => ({
                      ...prev,
                      pageNumber: validatedPage,
                    }));
                    setInputValue(validatedPage.toString());
                  }
                  e.target.blur();
                }
              }}
              inputProps={{
                style: { 
                  textAlign: 'center',
                  padding: '3px 0px 3px',
                  width: `${Math.max(20, inputValue.length * 10)}px`,
                },
              }}
              style={{ 
                marginRight: '5px',
              }}
            />
            <Typography variant="body1" component="span">
              / {pdfConfig.numPages}
            </Typography>
          </Box>
          
          <Tooltip title="Página siguiente">
            <IconButton
              aria-label="página siguiente"
              disabled={pdfConfig.pageNumber >= pdfConfig.numPages}
              onClick={() => setPdfConfig((prev) => ({
                ...prev,
                pageNumber: Math.min(pdfConfig.numPages, prev.pageNumber + 1),
              }))}
              color="inherit"
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </Tooltip>
        </Box>
      )}
      
      <Box style={{ 
        marginRight: 10,
      }}>
       
        
        {false && (
          <Tooltip title="Abrir en nueva pestaña">
            <IconButton
              aria-label="abrir en nueva pestaña"
              onClick={onOpenInNewTab}
              color="inherit"
            >
              <OpenInNewIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};

DocumentActionsBar.propTypes = {
  pdfConfig: PropTypes.object.isRequired,
  setPdfConfig: PropTypes.func.isRequired,
  onRotateLeft: PropTypes.func.isRequired,
  onRotateRight: PropTypes.func.isRequired,
  handleWidthSize: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onOpenInNewTab: PropTypes.func.isRequired,
  zoomSize: PropTypes.number,
  inputValue: PropTypes.string.isRequired,
  setInputValue: PropTypes.func.isRequired,
};

DocumentActionsBar.defaultProps = {
  zoomSize: 600,
};

export default DocumentActionsBar;
